export default __webpack_public_path__ + "static/media/Slide3.1fe6752c.svg";